import { render } from "./Main_Categories_Dialog.vue?vue&type=template&id=233865f1&scoped=true&ts=true"
import script from "./Main_Categories_Dialog.vue?vue&type=script&lang=ts"
export * from "./Main_Categories_Dialog.vue?vue&type=script&lang=ts"

import "./Main_Categories_Dialog.vue?vue&type=style&index=0&id=233865f1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233865f1"]])

export default __exports__